import CompanyFeaturePanel from "./CompanyFeaturePanel.container";

export default CompanyFeaturePanel;
